import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import {
    WDSButton,
    CarrierLogo,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import baseAppConfig from 'wanderu-shellapp/src/config/baseApp.locales';

import styles from './PriceUpComponent.scss';

const propTypes = {
    carrierCode: PropTypes.string,
    carrierName: PropTypes.string,
    i18nMoney: PropTypes.func,
    isRouted: PropTypes.bool,
    newPrice: PropTypes.arrayOf(PropTypes.object).isRequired,
    onContinue: PropTypes.func.isRequired,
    onGoBack: PropTypes.func.isRequired,
    onLoad: PropTypes.func.isRequired,
    originalPrice: PropTypes.arrayOf(PropTypes.object).isRequired,
    t: PropTypes.func,
};

const PriceUp = (props) => {
    const {
        carrierCode,
        carrierName = '',
        i18nMoney,
        isRouted = false,
        newPrice,
        onContinue,
        onGoBack,
        onLoad,
        originalPrice,
        t,
    } = props;

    useEffect(() => {
        if (onLoad) {
            onLoad();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const price = i18nMoney.format(i18nMoney(originalPrice).getTotalPrice());
    const newTotalPrice = i18nMoney.format(i18nMoney(newPrice).getTotalPrice());

    return (
        <div className={styles.container}>
            {carrierCode && <CarrierLogo
                carrierCode={carrierCode}
                carrierName={carrierName}
                className={styles.logo}
            />}
            <p>
                <Typography component="span">{t.plural(
                    'price-increase',
                    isRouted
                        ? 2
                        : 1,
                    { carrier: carrierName },
                )}</Typography><br/>
                <Typography component="span" variant="h6">{t('livecheck-price-up-change-from', { price })}</Typography>
                <Typography className={styles.newPrice} color="primary" component="span" variant="h2">{newTotalPrice}</Typography>
            </p>
            <span className={styles.buttonContainer}>
                <WDSButton
                    color="secondary"
                    label={t('price-increase-reject')}
                    onClick={onGoBack}
                    variant="outlined"
                    fullWidth
                >
                    {t('price-increase-reject')}
                </WDSButton>
                <WDSButton
                    color="secondary"
                    label={t('price-increase-accept')}
                    onClick={onContinue}
                    fullWidth
                >
                    {t('price-increase-accept')}
                </WDSButton>
            </span>
        </div>
    );
};

PriceUp.propTypes = propTypes;

export { PriceUp };
export default localize(PriceUp, baseAppConfig.namespace);
